'use client';
const IDENT = 'Skeleton';
const defaultProps = {
    color: 'button.secondary',
    accentColor: 'background.content',
    spacing: '0',
    align: 'center',
    textAlign: 'center',
    visible: true,
    animate: true,
    animation: 'wave'
};

export { IDENT, defaultProps };
//# sourceMappingURL=Skeleton.contract.js.map
